import { AfterViewInit, Component, ElementRef, HostListener, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EventosMonitoramentosDialogComponent } from 'src/app/shared/eventos-monitoramentos-dialog/eventos-monitoramentos-dialog.component';
import { LeituraEstacaoDialogComponent } from 'src/app/shared/leitura-estacao-dialog/leitura-estacao-dialog.component';
import { defaultMaker, Maker } from 'src/app/Interfaces/maker';
import { Map } from 'src/app/Interfaces/map';
import { EstacaoService } from 'src/services/estacao.service';
import * as moment from 'moment';
import { ResumoEventoDiaService } from 'src/services/resumo-evento.service';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { PessoaService } from 'src/services/pessoa.service';
import { SensorService } from 'src/services/sensor.service';
import { IntegracaoService } from 'src/services/integracao.service';
import { ColetaService } from 'src/services/coleta.service';
import { Router } from '@angular/router';
import { Observable, Subject, catchError, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PermissoesService } from 'src/services/permissoes.service';
import { normalizarDialogEstacao } from 'src/app/shared/evento-total';

const EVENTOS_TOTAL_IRREGULAR = [1, 3, 4, 5, 9];
type CorSituacao = 'verde' | 'preto' | 'vermelho' | 'amarelo' | 'azul' | 'cinza';
type LatLngLiteral = { lat: number; lng: number };
type StatePolygon = { id: number; uf: string; nome: string; paths: LatLngLiteral[][] };
type MunicipalityPolygon = { id: number; cidade_id: number; nome: string; uf: string; paths: LatLngLiteral[][] };
type PolygonOptions = Record<string, unknown>;
type MapOptions = Record<string, unknown>;
type GoogleMapInstance = {
  setCenter(center: unknown): void;
  getCenter(): unknown;
  setZoom?(zoom: number): void;
  fitBounds?(bounds: unknown): void;
};
type GoogleLatLngBoundsInstance = {
  extend(point: LatLngLiteral): void;
};
type GoogleMarkerInstance = {
  setMap(map: unknown): void;
  addListener(eventName: string, handler: () => void): void;
};
type GooglePolygonInstance = {
  setMap(map: unknown): void;
  addListener(eventName: string, handler: (event?: { latLng?: unknown; domEvent?: MouseEvent }) => void): void;
};
type GoogleMapsApi = {
  Map?: new (...args: any[]) => GoogleMapInstance;
  Marker?: new (...args: any[]) => GoogleMarkerInstance;
  Polygon?: new (...args: any[]) => GooglePolygonInstance;
  LatLngBounds?: new () => GoogleLatLngBoundsInstance;
  Size?: new (width: number, height: number) => unknown;
};

@Component({
    selector: 'app-bk-gmap',
    templateUrl: './bk-gmap.component.html',
    styleUrls: ['./bk-gmap.component.css'],
    standalone: false
})
export class BkGmapComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(LeituraEstacaoDialogComponent) leituraEstacaoDialog?: LeituraEstacaoDialogComponent;
  @ViewChild(EventosMonitoramentosDialogComponent) eventosMonitoramentosDialog?: EventosMonitoramentosDialogComponent;

  private readonly destroy$ = new Subject<void>();

  @Input() latitudeBase: number = -15.5989;

  @Input() longitudeBase: number = -56.0949;

  @Input() zoom: number = 7;

  loading: boolean = false;
  isHidden: boolean = false;
  isHiddenEvents: boolean = false;
  isHiddenStatistics: boolean = true;
  isFilterMobileHidden: boolean = false;
  exibirFiltroAvancado: boolean = false;
  modalNovoGrupo: boolean = false;
  modal: boolean = false;
  tituloModal: any
  makers: Maker[] = [];
  dropDownEstacao: any[] = [];
  dropDownGrupos: any[] = [];
  dropDownSensores: any[] = []
  dropDownClientes: any[] = []
  path: any[] = [];
  itens: any[] = [];
  private todosItensMapa: any[] = [];
  events: any[] = [];
  data: any[] = [];
  clientesFiltrados: any[] = [];
  estacao: any
  cliente: any
  sensor: any
  grupo: any
  estacao_id: any[] = []
  data_filtro: any = null
  ultima_data: any = null
  data_rota: any = null
  red = 'blue';

  readonly mapOptions: MapOptions = {
    disableDefaultUI: true,
    mapTypeId: 'satellite',
    mapTypeControl: false,
    clickableIcons: false,
    styles: [
      {
        featureType: 'administrative',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
      },
    ],
  };

  readonly infoWindowOptions = { disableAutoPan: true };

  googleMapsApiLoaded = false;
  googleMapsReady = false;
  mapDataReady = true;
  estacoesLoaded = false;
  statePolygonsLoaded = false;
  markerBuildToken = 0;
  pendingMarkerLoad = false;
  initialMarkerLoadDone = false;
  markersEnabled = false;
  advancedFiltersLoaded = false;
  statePolygons: StatePolygon[] = [];
  municipalityPolygons: MunicipalityPolygon[] = [];
  selectedStateUf: string | null = null;
  loadingMunicipalityPolygons = false;
  hoverHintVisible = false;
  hoverHintNome = '';
  hoverHintPosition: { x: number; y: number } = { x: 0, y: 0 };
  modalMunicipio = false;
  municipioSelecionado: MunicipalityPolygon | null = null;
  estacoesMunicipio: any[] = [];

  get mapCenter(): LatLngLiteral {
    return { lat: this.latitudeBase, lng: this.longitudeBase };
  }

  get polygonPaths(): LatLngLiteral[] {
    return (this.path || []) as LatLngLiteral[];
  }

  get polygonOptions(): PolygonOptions {
    return { strokeColor: this.red, visible: true };
  }

  /**
   * O wrapper leve já entrega a instância nativa pronta; daqui em diante
   * só precisamos marcar o mapa como disponível e disparar a primeira carga
   * de markers quando ela for explicitamente habilitada.
   */
  onGoogleMapInitialized(_map: any): void {
    this.googleMapsReady = true;
    this.renderNativePolygons();
    this.renderMunicipalityPolygons();

    if (this.markersEnabled && (!this.initialMarkerLoadDone || this.pendingMarkerLoad)) {
      this.pendingMarkerLoad = false;
      this.initialMarkerLoadDone = true;
      this.showMap();
    }
  }

  onGoogleMapsAuthFailure(): void {
    console.error(
      '[Google Maps] Falha de autenticação (chave, billing, Maps JavaScript API ou restrição de referrer).',
    );
  }

  private waitForGoogleMapsApi(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const startedAt = Date.now();
    const poll = () => {
      if (this.googleMapsApi?.Map) {
        this.googleMapsApiLoaded = true;
        this.tryInitializeNativeMap();
        return;
      }

      if (Date.now() - startedAt > 15000) {
        console.error('[Google Maps] API não ficou pronta a tempo para renderizar o mapa.');
        return;
      }

      window.setTimeout(poll, 50);
    };

    poll();
  }

  private get googleMapsApi(): GoogleMapsApi | undefined {
    return (globalThis as typeof globalThis & { google?: { maps?: GoogleMapsApi } }).google?.maps;
  }

  private scheduleMapInitializationAttempts(): void {
    if (typeof window === 'undefined') {
      return;
    }

    [0, 150, 500, 1000].forEach(delay => {
      window.setTimeout(() => this.tryInitializeNativeMap(), delay);
    });
  }

  private observeCanvasSize(canvasRef?: ElementRef<HTMLDivElement>): void {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    this.canvasResizeObserver?.disconnect();

    const canvas = canvasRef?.nativeElement;
    if (!canvas) {
      return;
    }

    this.canvasResizeObserver = new ResizeObserver(() => {
      if (!this.googleMapsReady) {
        this.tryInitializeNativeMap();
      }
    });

    this.canvasResizeObserver.observe(canvas);
  }

  private tryInitializeNativeMap(): void {
    if (!this.viewReady || this.nativeMap) {
      return;
    }

    const canvas = this.mapCanvas?.nativeElement;

    if (!canvas || canvas.offsetWidth === 0 || canvas.offsetHeight === 0 || !this.googleMapsApi?.Map) {
      this.mapInitRetryHandle = window.setTimeout(() => this.tryInitializeNativeMap(), 50);
      return;
    }

    this.nativeMap = new this.googleMapsApi.Map(canvas, {
      ...this.mapOptions,
      center: this.mapCenter,
      zoom: this.zoom,
    });

    this.onGoogleMapInitialized(this.nativeMap);
  }

  plu_filtro: any
  flu_filtro: any
  integrador_filtro: any[] = []
  coletor_filtro: any[] = []
  coresSelecionadas: CorSituacao[] = []
  readonly dropDownCores: Array<{ label: string; value: CorSituacao }> = [
    { label: 'Sem eventos ou monitoramento', value: 'verde' },
    { label: 'Evento sem monitoramento', value: 'preto' },
    { label: 'Monitoramento ativado (integração ou coleta)', value: 'vermelho' },
    { label: 'Monitoramento ativado (bateria/painel)', value: 'amarelo' },
    { label: 'Monitoramento ativado (nível)', value: 'azul' },
    { label: 'Monitoramento ativado (chuva)', value: 'cinza' },
  ]
  dropDownIntegradores: any[] = []
  dropDownColetores: any[] = []

  @ViewChild('multiSelect') multiSelect!: ElementRef;
  @ViewChild('mapCanvas')
  set mapCanvasRef(value: ElementRef<HTMLDivElement> | undefined) {
    this.mapCanvas = value;
    if (value) {
      this.observeCanvasSize(value);
      this.scheduleMapInitializationAttempts();
    }
  }

  mapCanvas?: ElementRef<HTMLDivElement>;
  device: 'desktop' | 'mobile' = 'desktop';
  user: any = {};
  private nativeMap?: GoogleMapInstance;
  private nativeMarkerInstances: GoogleMarkerInstance[] = [];
  private nativeStatePolygonInstances: GooglePolygonInstance[] = [];
  private nativeMunicipalityPolygonInstances: GooglePolygonInstance[] = [];
  private viewReady = false;
  private mapInitRetryHandle?: number;
  private canvasResizeObserver?: ResizeObserver;
  constructor(
    protected _estacaoService: EstacaoService,
    protected _resumoEventoService: ResumoEventoDiaService,
    protected _estacaoGrupoService: EstacaoGrupoService,
    protected _pessoaService: PessoaService,
    protected _sensorService: SensorService,
    protected _integracaoService: IntegracaoService,
    protected _coletorService: ColetaService,
    protected permissaoService: PermissoesService,
    private router: Router,
    private ngZone: NgZone,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') ?? '{}');
    this.device = this.resolveDevice();
    if (this.device === 'mobile') {
      this.isHiddenEvents = true;
    }
  }

  private resolveDevice(): 'desktop' | 'mobile' {
    if (typeof window !== 'undefined' && window.innerWidth < 992) {
      return 'mobile';
    }

    return localStorage.getItem('device') === 'mobile' ? 'mobile' : 'desktop';
  }

  private syncDeviceWithViewport(): void {
    const nextDevice = this.resolveDevice();
    if (this.device === nextDevice) {
      return;
    }

    this.device = nextDevice;
    this.nativeMap = undefined;
    this.googleMapsReady = false;
    this.scheduleMapInitializationAttempts();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.syncDeviceWithViewport();
  }

  ngOnInit(): void {
    this.syncDeviceWithViewport();
    this.waitForGoogleMapsApi();
    this.initializeMapFilters();
    this.loadStatePolygons();
    this.listEstacoes();
    this.showMap();
    this.pendingMarkerLoad = false;
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.scheduleMapInitializationAttempts();
    const panel = document.querySelector('.p-multiselect-panel');
    if (panel) {
      panel.classList.add('custom-panel');
    }
  }

  ngOnDestroy(): void {
    if (this.mapInitRetryHandle) {
      window.clearTimeout(this.mapInitRetryHandle);
    }
    this.canvasResizeObserver?.disconnect();
    this.clearNativeMarkers();
    this.clearNativeStatePolygons();
    this.clearMunicipalityPolygons();
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isUsuarioInterno(): boolean {
    return this.user?.usuario_interno === true;
  }

  get isUsuarioExterno(): boolean {
    return !this.isUsuarioInterno;
  }

  /** Classificação visual compartilhada pelo marcador, estatísticas e filtro interno. */
  corDaSituacao(situacao: any): CorSituacao {
    switch (Number(situacao)) {
      case 99:
        return 'verde';
      case 2:
        return 'vermelho';
      case 3:
        return 'amarelo';
      case 4:
        return 'azul';
      case 5:
        return 'cinza';
      case 1:
        return 'preto';
      default:
        return 'verde';
    }
  }

  private filtrarItensPorCor(itens: any[]): any[] {
    if (!this.isUsuarioInterno || !this.coresSelecionadas.length) {
      return itens || [];
    }

    const cores = new Set(this.coresSelecionadas);
    return (itens || []).filter(item => cores.has(this.corDaSituacao(item?.situacao)));
  }

  private get clienteIdsDoUsuario(): number[] {
    const ids = new Set<number>();
    const empresaId = Number(this.user?.empresa_id);
    if (Number.isFinite(empresaId) && empresaId > 0) {
      ids.add(empresaId);
    }

    const empresas = Array.isArray(this.user?.empresas) ? this.user.empresas : [];
    for (const item of empresas) {
      const id = Number(item?.empresa_id ?? item?.empresa?.id);
      if (Number.isFinite(id) && id > 0) {
        ids.add(id);
      }
    }

    return [...ids];
  }

  private pertenceAosClientesDoUsuario(clienteId: any): boolean {
    const ids = this.clienteIdsDoUsuario;
    if (!ids.length) {
      return false;
    }
    return ids.includes(Number(clienteId));
  }

  get estatisticasSelecao(): {
    total: number;
    itens: Array<{
      key: string;
      label: string;
      dotClass: string;
      quantidade: number;
      percentual: string;
    }>;
  } {
    const contagens = {
      verde: 0,
      preto: 0,
      vermelho: 0,
      amarelo: 0,
      azul: 0,
      cinza: 0,
    };

    for (const item of this.itens || []) {
      contagens[this.corDaSituacao(item?.situacao)] += 1;
    }

    const total = Object.values(contagens).reduce((acc, n) => acc + n, 0);
    const percentual = (quantidade: number): string => {
      if (total === 0) {
        return '0.0';
      }
      return ((quantidade / total) * 100).toFixed(1);
    };

    return {
      total,
      itens: [
        {
          key: 'verde',
          label: 'Sem eventos ou monitoramento',
          dotClass: 'green-dot',
          quantidade: contagens.verde,
          percentual: percentual(contagens.verde),
        },
        {
          key: 'preto',
          label: 'Evento sem monitoramento',
          dotClass: 'black-dot',
          quantidade: contagens.preto,
          percentual: percentual(contagens.preto),
        },
        {
          key: 'vermelho',
          label: 'Monitoramento ativado (integração ou coleta)',
          dotClass: 'red-dot',
          quantidade: contagens.vermelho,
          percentual: percentual(contagens.vermelho),
        },
        {
          key: 'amarelo',
          label: 'Monitoramento ativado (bateria/painel)',
          dotClass: 'yellow-dot',
          quantidade: contagens.amarelo,
          percentual: percentual(contagens.amarelo),
        },
        {
          key: 'azul',
          label: 'Monitoramento ativado (nível)',
          dotClass: 'blue-dot',
          quantidade: contagens.azul,
          percentual: percentual(contagens.azul),
        },
        {
          key: 'cinza',
          label: 'Monitoramento ativado (chuva)',
          dotClass: 'gray-dot',
          quantidade: contagens.cinza,
          percentual: percentual(contagens.cinza),
        },
      ],
    };
  }

  toggleEstatisticas(): void {
    this.isHiddenStatistics = !this.isHiddenStatistics;
  }

  getIconeEvento(row: any): string {
    if (Number(row?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return row?.tipo_evento?.icone || row?.icone || '';
  }

  abrirLeiturasEstacao(): void {
    const estacaoId = Number(this.estacao?.id);
    const dataResumo = this.data_rota || this.ultima_data;

    if (!estacaoId || !dataResumo) {
      return;
    }

    this.leituraEstacaoDialog?.abrir({
      estacaoId,
      dataResumo,
      estacaoDescricao: this.estacao?.descricao,
    });
  }

  getIconeMonitoramento(row: any): string {
    if (Number(row?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return row?.icone || 'pi pi-eye';
  }

  monitoramentoEstaAberto(row: any): boolean {
    return Number(row?.status) === 0;
  }

  get podeAbrirMonitoramento(): boolean {
    return this.permissaoService.can('resumo_eventos_abrir_monitoramentos');
  }

  private dataResumoEstacaoDialog(): string {
    return moment(this.data_rota || this.data_filtro).format('YYYY-MM-DD');
  }

  abrirNovoMonitoramentoEstacao(event?: Event): void {
    event?.stopPropagation();
    if (!this.podeAbrirMonitoramento || !this.estacao?.id) {
      return;
    }

    this.eventosMonitoramentosDialog?.abrirNovoPorEstacao({
      estacaoId: Number(this.estacao.id),
      estacaoDescricao: this.estacao.descricao || '',
      dataResumo: this.dataResumoEstacaoDialog(),
    });
  }

  abrirMonitoramentoEstacao(row: any): void {
    const monitoramentoId = Number(row?.id);
    if (!this.podeAbrirMonitoramento || !monitoramentoId || !this.estacao?.id) {
      return;
    }

    this.eventosMonitoramentosDialog?.abrirPorMonitoramento({
      estacaoId: Number(this.estacao.id),
      estacaoDescricao: this.estacao.descricao || '',
      dataResumo: this.dataResumoEstacaoDialog(),
      monitoramentoId,
    });
  }

  onMonitoramentoSalvo(): void {
    if (!this.estacao?.id) {
      return;
    }

    this.loadStationDetails(Number(this.estacao.id), this.dataResumoEstacaoDialog());
  }

  listIntegrador(){
    this._integracaoService.index().pipe(takeUntil(this.destroy$)).subscribe(json => {
      this.dropDownIntegradores = json
    })
  }

  listColetor(){
    this._coletorService.index().pipe(takeUntil(this.destroy$)).subscribe(json => {
      this.dropDownColetores = json
    })
  }

  listGrupos(){
    this.dropDownGrupos = []
    this._estacaoGrupoService.index().pipe(takeUntil(this.destroy$)).subscribe(json => {
      const grupos = this.filtrarGruposDoUsuarioExterno(json || []);
      grupos.map(item => {
        this.dropDownGrupos.push({
          label: item.nome, value: item.id
        })
        
      })
    })
  }

  listClientes(){
    this.dropDownClientes = []
    const request$ = this.isUsuarioExterno
      ? this._pessoaService.listEmpresas()
      : this._pessoaService.index();
    request$.pipe(takeUntil(this.destroy$)).subscribe(json => {
      let ret = json.filter(x => x.ativo == true)
      if (this.isUsuarioExterno) {
        const ids = this.clienteIdsDoUsuario;
        if (ids.length) {
          ret = ret.filter(item => this.pertenceAosClientesDoUsuario(item.id));
        }
      }
      ret.map(item => {
        this.dropDownClientes.push({
          label: item.nome, value: item.id
        })
        
      })
    })
  }

  filtrarClientes(event) {
    let query = event.query;
    this._pessoaService.autocomplete(query).pipe(takeUntil(this.destroy$)).subscribe((json) => {
        let clientes = [];
        json.map((item) => {
            clientes.push({
                value: item.value,
                label: item.label,
            });
            this.clientesFiltrados = clientes;
        });
    });
}

listSensores(){
  this.dropDownSensores = []
  this._sensorService.index().pipe(takeUntil(this.destroy$)).subscribe(json => {
    const sensores = this.filtrarSensoresDoUsuarioExterno(json || []);
    sensores.map(item => {
      
        this.dropDownSensores.push({
          value: item.id, label: item.descricao,
        })
  
     
    })
  })
}

  private filtrarGruposDoUsuarioExterno(grupos: any[]): any[] {
    if (!this.isUsuarioExterno) {
      return grupos;
    }

    const ids = this.clienteIdsDoUsuario;
    if (!ids.length) {
      return grupos;
    }

    return grupos.filter(grupo => {
      if (this.pertenceAosClientesDoUsuario(grupo?.empresa_id)) {
        return true;
      }
      return (grupo?.estacoes || []).some((estacao: any) =>
        this.pertenceAosClientesDoUsuario(estacao?.cliente_id ?? estacao?.cliente?.id)
      );
    });
  }

  private filtrarSensoresDoUsuarioExterno(sensores: any[]): any[] {
    if (!this.isUsuarioExterno) {
      return sensores;
    }

    const ids = this.clienteIdsDoUsuario;
    if (!ids.length) {
      return sensores;
    }

    return sensores.filter(sensor =>
      this.pertenceAosClientesDoUsuario(
        sensor?.estacao?.cliente_id ?? sensor?.estacao?.cliente?.id
      )
    );
  }

  // ngOnChanges(): void {
  //   this.showMap();
  // }

  toggleFloatingBar(): void {
    this.isHidden = !this.isHidden;
  }

  toggleFilterMobile(): void {
    this.isFilterMobileHidden = !this.isFilterMobileHidden;

    if (!this.isFilterMobileHidden) {
      this.scheduleMapInitializationAttempts();
    }
  }

  toggleEventos(){
    this.isHiddenEvents = !this.isHiddenEvents;
    
  }

 

  private initializeMapFilters(): void {
    const hoje = new Date();
    const ontem = new Date(hoje);
    this.data_filtro = moment(ontem.setDate(hoje.getDate() - 1)).format('YYYY-MM-DD');
  }

  listEstacoes(){
    if (this.estacoesLoaded) {
      return;
    }
    this.dropDownEstacao = []
    this._estacaoService.lookup().pipe(takeUntil(this.destroy$)).subscribe(json => {
      json.map(item => {
        this.dropDownEstacao.push({
          label: item.descricao, value: item.id
        })
        
      })
      this.estacoesLoaded = true;
    })
  }

  toggleFiltroAvancado(): void {
    if (!this.exibirFiltroAvancado && !this.advancedFiltersLoaded) {
      this.loadAdvancedFilters();
    }
    this.exibirFiltroAvancado = !this.exibirFiltroAvancado;
  }

  private loadAdvancedFilters(): void {
    this.advancedFiltersLoaded = true;
    this.listGrupos();
    this.listSensores();
    this.listClientes();
    this.listIntegrador();
    this.listColetor();
  }

  changeDate(event){
    if(event == 'amanha'){
     this.ultima_data = moment(this.ultima_data, "YYYY-MM-DD") 
    .utc().add(1, 'days')
    } else {
      this.ultima_data = moment(this.ultima_data, "YYYY-MM-DD") 
    .utc().subtract(1, 'days')
    }
    this.loadStationDetails(this.estacao?.id, moment(this.ultima_data).format('YYYY-MM-DD'));
  }

  sortByKey(array: any, key: any, type = 'asc') {
    return array.sort(function (a: any, b: any) {
      if (type == 'asc') {
        var x = a[key]; var y = b[key];
      } else {
        var x = b[key]; var y = a[key];
      }
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  onMarkerClick(marker: any) {
    console.log('onMarkerClick chamado', { 
      isUsuarioInterno: this.isUsuarioInterno, 
      marker: marker 
    });
    
    // Se não for usuário interno, navega para a tela de Leituras
    if (!this.isUsuarioInterno) {
      console.log('Usuário externo detectado, redirecionando...');
      // Encontra a estação correspondente ao marker
      const estacao = this.itens.find(item => item.descricao == marker.description);
      console.log('Estação encontrada:', estacao);
      
      if (estacao && estacao.id) {
        // Calcula o período: 30 dias atrás até hoje
        const dataInicial = moment().subtract(30, 'days').format('YYYY-MM-DD');
        const dataFinal = moment().format('YYYY-MM-DD');
        
        console.log('Navegando para:', {
          rota: ['dashboard', estacao.id, 'tabela'],
          queryParams: { 
            dataInicial: dataInicial,
            dataFinal: dataFinal
          }
        });
        
        // Navega para a tela de Leituras (tabela) com a estação e período selecionados
        // A rota é: dashboard/:id/tabela com as datas como query parameters
        // O DashboardComponent vai aplicar automaticamente a estação e período nos filtros
        this.router.navigate(['dashboard', estacao.id, 'tabela'], {
          queryParams: { 
            dataInicial: dataInicial,
            dataFinal: dataFinal
          }
        });
      } else {
        console.error('Estação não encontrada ou sem ID');
      }
      return;
    }

    const estacao = this.itens.find(item => item.descricao == marker.description);
    if (!estacao?.id) {
      return;
    }

    this.estacao = estacao;
    this.ultima_data = this.data_filtro;
    this.modal = true;
    this.loadStationDetails(estacao.id, moment(this.data_filtro).format('YYYY-MM-DD'));

  }

  showMap() {
    this.markersEnabled = true;

    if (!this.googleMapsReady) {
      this.pendingMarkerLoad = true;
      this.scheduleMapInitializationAttempts();
      return;
    }

    this.loading = true;
    this.markerBuildToken += 1;

    let estacoes: any = []
    let grupos: any = []
    let clientes: any = []
    let sensores: any = []

    if(this.estacao_id){
      this.estacao_id.map(item => {
        estacoes.push(item.value)
      })
    }
    if(this.grupo){
      this.grupo.map(item => {
        grupos.push(item.value)
      })
    }
    if(this.cliente){
      this.cliente.map(item => {
        clientes.push(item.value)
      })
    }
    if(this.sensor){
      this.sensor.map(item => {
        sensores.push(item.value)
      })
    }

    let integradores: any[] = []
    let coletores: any[] = []

    if(integradores){
      this.integrador_filtro.map(item => {
        integradores.push(item.id)
      })
    }

    if(coletores){
      this.coletor_filtro.map(item => {
        coletores.push(item.id)
      })
  }

   


    this.makers = [];

    const dataFiltroFormatada = moment(this.data_filtro).format('YYYY-MM-DD');

    this.buscarItensMapa(
      dataFiltroFormatada,
      estacoes,
      grupos,
      clientes,
      sensores,
      integradores,
      coletores,
    ).pipe(
      catchError(() => {
        this.itens = [];
        this.todosItensMapa = [];
        this.makers = [];
        this.loading = false;
        return of([]);
      }),
      takeUntil(this.destroy$),
    ).subscribe(json => {
      this.todosItensMapa = json || [];
      this.itens = this.filtrarItensPorCor(this.todosItensMapa);

      if (!this.itens.length) {
        this.makers = [];
        this.renderNativeMarkers();
        this.loading = false;
        return;
      }

      const buildToken = this.markerBuildToken;
      const makers = this.itens
        .map((item) => this.buildMarker(item, item))
        .filter((marker): marker is Maker => marker !== null);

      if (buildToken !== this.markerBuildToken) {
        return;
      }

      this.makers = makers;
      this.renderNativeMarkers();
      this.loading = false;
    })


    

  }

  private buscarItensMapa(
    dataFiltro: string,
    estacoes: any[],
    grupos: any[],
    clientes: any[],
    sensores: any[],
    integradores: any[],
    coletores: any[],
  ): Observable<any> {
    return this._resumoEventoService.filterMap(
      dataFiltro,
      dataFiltro,
      estacoes,
      grupos,
      clientes,
      sensores,
      this.plu_filtro,
      this.flu_filtro,
      integradores,
      coletores,
      !this.isUsuarioInterno
    ).pipe(
      catchError((error) => {
        if (error?.status !== 404) {
          throw error;
        }

        console.warn(
          '[Mapa] Endpoint resumo-evento-dia/groupby/estacao/map indisponivel. Usando fallback groupby/estacao.',
        );

        return this._resumoEventoService.filter(
          dataFiltro,
          dataFiltro,
          estacoes,
          grupos,
          clientes,
          sensores,
          this.plu_filtro,
          this.flu_filtro,
          integradores,
          coletores,
          [],
          true,
          !this.isUsuarioInterno
        );
      }),
    );
  }

  private loadStationDetails(estacaoId: number, data: string): void {
    if (!estacaoId) {
      return;
    }

    this.loading = true;
    this.data = [];
    this.data_rota = data;
    this.tituloModal = `${this.estacao?.descricao || 'Estação'} - ${moment(data).format('DD/MM/YYYY')}`;

    this._resumoEventoService.mapDialog(estacaoId, data).pipe(
      takeUntil(this.destroy$),
    ).subscribe({
      next: (json) => {
        const dialogo = normalizarDialogEstacao(json);
        this.estacao = dialogo || this.estacao;
        this.data = dialogo ? [dialogo] : [];
        this.loading = false;
      },
      error: () => {
        this.data = [];
        this.loading = false;
      }
    });
  }

  private loadStatePolygons(): void {
    if (this.statePolygonsLoaded) {
      return;
    }

    this.statePolygonsLoaded = true;

    this._resumoEventoService.statePolygons().pipe(
      takeUntil(this.destroy$),
    ).subscribe({
      next: (json) => {
        this.statePolygons = Array.isArray(json) ? json : [];
        this.renderNativePolygons();
      },
      error: () => {
        this.statePolygons = [];
      }
    });
  }

  private renderNativePolygons(): void {
    if (!this.nativeMap) {
      return;
    }

    this.clearNativeStatePolygons();

    const PolygonCtor = this.googleMapsApi?.Polygon;
    if (!PolygonCtor) {
      return;
    }

    this.nativeStatePolygonInstances = (this.statePolygons || []).flatMap((estado) =>
      (estado?.paths || [])
        .filter((path) => Array.isArray(path) && path.length >= 3)
        .map((path) => {
          const isSelected = this.selectedStateUf === estado.uf;
          const exibirMunicipios = isSelected && this.municipalityPolygons.length > 0;
          const polygon = new PolygonCtor({
            map: this.nativeMap,
            paths: path,
            clickable: true,
            draggable: false,
            editable: false,
            geodesic: false,
            strokeColor: isSelected ? '#1e3a8a' : '#3a3d42',
            strokeOpacity: isSelected ? 1 : 0.9,
            strokeWeight: isSelected ? 3.5 : 2.5,
            fillColor: isSelected ? '#1d4ed8' : '#8b8f97',
            fillOpacity: exibirMunicipios ? 0.08 : (isSelected ? 0.55 : 0.2),
            zIndex: 1,
          });

          polygon.addListener('click', () => {
            this.ngZone.run(() => this.onStatePolygonClick(estado));
          });

          return polygon;
        }),
    );
  }

  private onStatePolygonClick(estado: StatePolygon): void {
    if (!estado?.uf) {
      return;
    }

    this.selectedStateUf = estado.uf;
    this.renderNativePolygons();
    this.loadMunicipalityPolygons(estado.uf);
  }

  private loadMunicipalityPolygons(uf: string): void {
    this.loadingMunicipalityPolygons = true;
    this.hoverHintVisible = false;
    this.fecharDialogMunicipio();
    this.clearMunicipalityPolygonInstances();
    this.municipalityPolygons = [];

    this._resumoEventoService.municipalityPolygons(uf).pipe(
      takeUntil(this.destroy$),
    ).subscribe({
      next: (response) => {
        const municipios = Array.isArray(response?.municipios) ? response.municipios : [];
        this.municipalityPolygons = municipios.filter(
          (municipio) => Array.isArray(municipio?.paths) && municipio.paths.some((path) => path.length >= 3),
        );

        const totalRegistros = Number(response?.total_registros ?? municipios.length);
        const totalComPoligono = Number(response?.total_com_poligono ?? this.municipalityPolygons.length);
        if (totalRegistros > totalComPoligono) {
          console.warn(
            `[Mapa] UF ${uf}: ${totalComPoligono}/${totalRegistros} municípios com polígono válido.`,
            response?.sem_poligono ?? [],
          );
        }

        this.renderNativePolygons();
        this.renderMunicipalityPolygons();
        this.fitMapToSelectedPolygons();
        this.loadingMunicipalityPolygons = false;
      },
      error: () => {
        this.municipalityPolygons = [];
        this.clearMunicipalityPolygons();
        this.loadingMunicipalityPolygons = false;
      },
    });
  }

  private renderMunicipalityPolygons(): void {
    if (!this.nativeMap) {
      return;
    }

    this.clearMunicipalityPolygonInstances();

    const PolygonCtor = this.googleMapsApi?.Polygon;
    if (!PolygonCtor) {
      return;
    }

    this.nativeMunicipalityPolygonInstances = (this.municipalityPolygons || []).flatMap((municipio) =>
      (municipio?.paths || [])
        .filter((path) => Array.isArray(path) && path.length >= 3)
        .map((path) => {
          const polygon = new PolygonCtor({
            map: this.nativeMap,
            paths: path,
            clickable: true,
            draggable: false,
            editable: false,
            geodesic: false,
            strokeColor: '#0f172a',
            strokeOpacity: 0.95,
            strokeWeight: 2,
            fillColor: '#f8fafc',
            fillOpacity: 0.35,
            zIndex: 5,
          });

          polygon.addListener('mouseover', (event: { latLng?: unknown; domEvent?: MouseEvent }) => {
            this.ngZone.run(() => {
              this.hoverHintNome = municipio.nome || '';
              this.atualizarPosicaoHoverHint(event?.domEvent);
              this.hoverHintVisible = true;
            });
          });

          polygon.addListener('mousemove', (event: { latLng?: unknown; domEvent?: MouseEvent }) => {
            this.ngZone.run(() => {
              if (!this.hoverHintVisible) {
                return;
              }
              this.atualizarPosicaoHoverHint(event?.domEvent);
            });
          });

          polygon.addListener('mouseout', () => {
            this.ngZone.run(() => {
              this.hoverHintVisible = false;
            });
          });

          polygon.addListener('click', () => {
            this.ngZone.run(() => {
              this.onMunicipioPolygonClick(municipio);
            });
          });

          return polygon;
        }),
    );
  }

  private fitMapToSelectedPolygons(): void {
    if (!this.nativeMap?.fitBounds || !this.googleMapsApi?.LatLngBounds) {
      return;
    }

    const poligonos = this.municipalityPolygons.length > 0
      ? this.municipalityPolygons
      : this.statePolygons.filter((estado) => estado.uf === this.selectedStateUf);

    if (!poligonos.length) {
      return;
    }

    const bounds = new this.googleMapsApi.LatLngBounds();
    let hasPoint = false;

    for (const poligono of poligonos) {
      for (const path of poligono.paths || []) {
        for (const point of path) {
          if (Number.isFinite(point.lat) && Number.isFinite(point.lng)) {
            bounds.extend(point);
            hasPoint = true;
          }
        }
      }
    }

    if (hasPoint) {
      this.nativeMap.fitBounds(bounds);
    }
  }

  onMunicipioPolygonClick(municipio: MunicipalityPolygon): void {
    this.hoverHintVisible = false;
    this.municipioSelecionado = municipio;
    this.estacoesMunicipio = (this.itens || []).filter((item) => this.estacaoDentroDoMunicipio(item, municipio));
    this.modalMunicipio = true;
  }

  fecharDialogMunicipio(): void {
    this.modalMunicipio = false;
  }

  private estacaoDentroDoMunicipio(estacao: any, municipio: MunicipalityPolygon): boolean {
    const point = this.extrairCoordenadaEstacao(estacao);
    if (!point) {
      return false;
    }

    return (municipio.paths || []).some((path) => this.pontoDentroDoPoligono(point, path));
  }

  private extrairCoordenadaEstacao(estacao: any): LatLngLiteral | null {
    const latitude = parseFloat(String(estacao?.latitude ?? '').replace(',', '.'));
    const longitude = parseFloat(String(estacao?.longitude ?? '').replace(',', '.'));

    if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
      return null;
    }

    return { lat: latitude, lng: longitude };
  }

  private pontoDentroDoPoligono(point: LatLngLiteral, path: LatLngLiteral[]): boolean {
    if (!Array.isArray(path) || path.length < 3) {
      return false;
    }

    let inside = false;
    const x = point.lng;
    const y = point.lat;

    for (let i = 0, j = path.length - 1; i < path.length; j = i++) {
      const xi = path[i].lng;
      const yi = path[i].lat;
      const xj = path[j].lng;
      const yj = path[j].lat;
      const intersecta = ((yi > y) !== (yj > y))
        && (x < ((xj - xi) * (y - yi)) / ((yj - yi) || Number.EPSILON) + xi);

      if (intersecta) {
        inside = !inside;
      }
    }

    return inside;
  }

  private atualizarPosicaoHoverHint(mouseEvent?: MouseEvent): void {
    const offset = 15;

    if (mouseEvent) {
      this.hoverHintPosition = {
        x: mouseEvent.clientX + offset,
        y: mouseEvent.clientY + offset,
      };
      return;
    }

    this.hoverHintPosition = {
      x: Math.round(window.innerWidth / 2),
      y: Math.round(window.innerHeight / 2),
    };
  }

  private renderNativeMarkers(): void {
    if (!this.nativeMap) {
      return;
    }

    this.clearNativeMarkers();

    const MarkerCtor = this.googleMapsApi?.Marker;
    if (!MarkerCtor) {
      return;
    }

    this.nativeMarkerInstances = (this.makers || []).map((marker) => {
      const instance = new MarkerCtor({
        map: this.nativeMap,
        position: {
          lat: marker.latitude as number,
          lng: marker.longitude as number,
        },
        title: marker.description,
        icon: this.toGoogleMarkerIcon(marker),
        zIndex: 1000,
      });

      instance.addListener('click', () => {
        this.ngZone.run(() => this.onMarkerClick(marker));
      });
      return instance;
    });
  }

  private clearNativeMarkers(): void {
    this.nativeMarkerInstances.forEach((marker) => marker.setMap(null));
    this.nativeMarkerInstances = [];
  }

  private clearNativeStatePolygons(): void {
    this.nativeStatePolygonInstances.forEach((polygon) => polygon.setMap(null));
    this.nativeStatePolygonInstances = [];
  }

  private clearMunicipalityPolygonInstances(): void {
    this.nativeMunicipalityPolygonInstances.forEach((polygon) => polygon.setMap(null));
    this.nativeMunicipalityPolygonInstances = [];
  }

  private clearMunicipalityPolygons(): void {
    this.clearMunicipalityPolygonInstances();
    this.municipalityPolygons = [];
    this.hoverHintVisible = false;
  }

  private toGoogleMarkerIcon(marker: Maker): Record<string, unknown> | string | undefined {
    const icon = marker.icon;
    if (!icon?.url) {
      return undefined;
    }

    const GoogleMapsSize = this.googleMapsApi?.Size;
    if (!GoogleMapsSize) {
      return icon.url;
    }

    return {
      url: icon.url,
      scaledSize: new GoogleMapsSize(
        icon.scaledSize?.width ?? 32,
        icon.scaledSize?.height ?? 32,
      ),
    };
  }

 addNovoGrupo(){
  if (!this.advancedFiltersLoaded) {
    this.loadAdvancedFilters();
  }
  this.modalNovoGrupo = true
 }

  aoSalvarNovoGrupo(): void {
  this.listGrupos()
  this.modalNovoGrupo = false;
}

private buildMarker(item: any, response: any): Maker | null {
  const latitude = parseFloat(String(item.latitude || '').replace(',', '.'));
  const longitude = parseFloat(String(item.longitude || '').replace(',', '.'));

  if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
    return null;
  }

  let situacao;
  let ultima_data_hora_sistema: string | null = null;

  if (typeof response === 'object' && response !== null && !Array.isArray(response)) {
    situacao = response.situacao;
    ultima_data_hora_sistema = response.ultima_data_hora_sistema || null;
  } else {
    situacao = response;
  }

  let icon = 'assets/layout/images/pin-black.png';

  if (this.isUsuarioInterno) {
    const iconsByColor: Record<CorSituacao, string> = {
      verde: 'assets/layout/images/pin-green.png',
      preto: 'assets/layout/images/pin-black.png',
      vermelho: 'assets/layout/images/pin-red.png',
      amarelo: 'assets/layout/images/pin-yellow.png',
      azul: 'assets/layout/images/pin-blue.png',
      cinza: 'assets/layout/images/pin-gray.png',
    };
    icon = iconsByColor[this.corDaSituacao(situacao)];
  } else if (situacao == 99) {
    icon = 'assets/layout/images/pin-green.png';
  } else if (situacao == 2 || situacao == 3 || situacao == 4 || situacao == 5) {
    icon = 'assets/layout/images/pin-yellow.png';
  } else {
    icon = 'assets/layout/images/pin-red.png';
  }

  return {
    latitude,
    longitude,
    description: item['descricao'],
    ultima_data_hora_sistema,
    icon: {
      url: icon,
      scaledSize: {
        height: 32,
        width: 32
      }
    }
  };
}

formatDateTime(dateTimeString: string | null | undefined): string {
  if (!dateTimeString || dateTimeString === 'null' || dateTimeString === null || dateTimeString === undefined) return '-';
  // Formato esperado: "2025-12-21 14:30:00"
  try {
    const formatted = moment(dateTimeString, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    return formatted === 'Invalid date' ? '-' : formatted;
  } catch (e) {
    return '-';
  }
}

}
